import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AuthInitialState } from './auth.types'
import { userMock } from './auth.fixtures'

const initialState: AuthInitialState = {
  userId: '',
  user: userMock,
  featuresByCompany: {},
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserId: (
      state,
      action: PayloadAction<{ userId: AuthInitialState['userId'] }>
    ) => {
      state.userId = action.payload.userId
    },
    clearUserId: (state) => {
      state.userId = ''
    },
    setUser: (
      state,
      action: PayloadAction<{ user: AuthInitialState['user'] }>
    ) => {
      state.user = action.payload.user
    },
    setUserCompanyFeatures: (
      state,
      action: PayloadAction<{
        featuresByCompany: AuthInitialState['featuresByCompany']
      }>
    ) => {
      state.featuresByCompany = action.payload.featuresByCompany
    },
    setUserCompanyFeature: (
      state,
      action: PayloadAction<{
        companyId: string
        featureName: 'WAYBILL'
        enabled: boolean
      }>
    ) => {
      if (!state.featuresByCompany[action.payload.companyId]) {
        state.featuresByCompany[action.payload.companyId] = {}
      }
      state.featuresByCompany[action.payload.companyId][
        action.payload.featureName
      ] = action.payload.enabled
    },
  },
})

export const { setUserId, clearUserId, setUser, setUserCompanyFeatures, setUserCompanyFeature } =
  authSlice.actions

export default authSlice.reducer
